import { createReducerUsingActionHandlers, ERROR, PENDING, SUCCESS } from '@travel-frontend/state-handling-sdk';
import { createSelector } from 'reselect';
import { ADD_TO_WISHLIST, FETCH_WISHLIST_METADATA, REMOVE_FROM_WISHLIST, SYNC_SESSION_WITH_CUSTOMER } from '../../../../components/Wishlist/redux/wishlist-meta/models.js';
import { wishlistMetaState } from '../../../../components/Wishlist/redux/wishlist-meta/WishlistMetaState.js';
const initialState = {
  isLoading: false,
  error: null,
  data: null,
  syncedCustomerId: null
};
const actionCreators = {
  [PENDING(FETCH_WISHLIST_METADATA)]: state => ({
    ...state,
    isLoading: true
  }),
  [SUCCESS(FETCH_WISHLIST_METADATA)]: (state, action) => ({
    ...state,
    data: action.data,
    isLoading: false
  }),
  [ERROR(FETCH_WISHLIST_METADATA)]: (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false
  }),
  [SUCCESS(ADD_TO_WISHLIST)]: (state, action) => {
    if (!state.data) return state;
    const hotelIds = state.data.allHotelIDs;
    const isIncluded = hotelIds.includes(action.hotelId);
    const updatedLists = state.data.lists.map(list => {
      const {
        hotelIDs = []
      } = list;
      return {
        ...list,
        hotelIDs: hotelIDs.includes(action.hotelId) ? hotelIDs : [...hotelIDs, action.hotelId]
      };
    });
    return {
      ...state,
      data: {
        ...state.data,
        allHotelIDs: isIncluded ? hotelIds : [...hotelIds, action.hotelId],
        lists: updatedLists
      }
    };
  },
  [SUCCESS(REMOVE_FROM_WISHLIST)]: (state, action) => {
    if (!state.data) return state;
    return {
      ...state,
      data: {
        ...state.data,
        allHotelIDs: state.data.allHotelIDs.filter(id => id !== action.hotelId),
        lists: state.data.lists.map(list => ({
          ...list,
          hotelIDs: list.hotelIDs.filter(id => id !== action.hotelId)
        }))
      }
    };
  },
  [SUCCESS(SYNC_SESSION_WITH_CUSTOMER)]: (state, action) => ({
    ...state,
    syncedCustomerId: action.customerId
  }),
  [ERROR(SYNC_SESSION_WITH_CUSTOMER)]: (state, action) => ({
    ...state,
    syncedCustomerId: action.customerId
  })
};
export const wishlistMetaReducer = createReducerUsingActionHandlers(initialState, actionCreators);
export const selectAllHotelsCount = createSelector(wishlistMetaState, wishlistMetaState => wishlistMetaState.data?.allHotelIDs.length || 0);
export const selectAllHotelsList = createSelector(wishlistMetaState, wishlistMetaState => wishlistMetaState.data?.allHotelIDs || []);